import useRequest, {
    RequestKeys,
    RequestFn,
} from 'app/hooks/useRequest'

import requests from 'app/requests/Order/Order.requests'
import {
    BillingInformationType,
    BillingInformationResponse,
} from '../../orders.types'

const useGetBillingInformation = (
    orderNumber: string,
): BillingInformationResponse => {
    const {
        data,
        isDataReady,
        isFetching,
        isError,
        error,
    } = useRequest<BillingInformationType>({
        key: RequestKeys.getBillingInformation,
        params: {
            orderNumber,
        },
        requestFunc: RequestFn.getEntity(requests.getBillingInformation),
        enabled: Boolean(orderNumber),
    })

    return {
        billingInformation: data,
        isDataReady,
        isFetching,
        isError,
        error,
    }
}

export default useGetBillingInformation
